import { Lock } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export function ScreenExpired() {
  return (
    <div className="w-full max-w-[400px] text-center mt-12">
      <Card>
        <CardContent className="flex flex-col items-center gap-4 py-8">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
            <Lock className="h-8 w-8 text-gray-400" />
          </div>
          <h1 className="text-xl font-semibold text-gray-700">
            Le lien est inactif
          </h1>
          <p className="text-[15px] text-gray-500 leading-relaxed">
            Ce lien d'import a expiré ou a déjà été utilisé.
            <br />
            Veuillez demander un nouveau QR code à votre conseiller.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
